import React from 'react';
import { Bubbles } from '../Loading';
import './style.less';

const SectionLoading = () => {
  return (
    <div className="section-loading">
      <Bubbles />
    </div>
  );
};

export default SectionLoading;
